export const PEEK_COOKIE = 'peek_header_on';

export const isPeekPageRegex = /.+peek$/;
